import React from 'react';
import { Label } from './ui/label';
import { Select } from './ui/select';

export default function NistScenarioSelector({ label, scenarios, value, onChange }) {
  const selected = scenarios.find((s) => s.value === value) || scenarios[0];

  return (
    <div className="space-y-2">
      <Label className="text-gray-700 font-medium">{label}</Label>
      <Select value={value} onChange={(e) => onChange(e.target.value)} className="w-full">
        {scenarios.map((s) => (
          <option key={s.value} value={s.value}>
            {s.label}
          </option>
        ))}
      </Select>
      {selected?.hint && <p className="text-xs text-gray-500">{selected.hint}</p>}
    </div>
  );
}
